document.addEventListener("turbo:load", () => {
  const container = document.getElementById("event_show_container");
  if (!container) return;

	console.log('Load: events/total_raised_countdown.js');

  const {
    eventStart,
    eventEnd,
    eventShowCountdown
  } = container.dataset;

  const showCountdown = eventShowCountdown === "true";
  const now = Date.now();
  const hasStarted = eventStart && now > Date.parse(eventStart);
  const hasEnded = eventEnd && now > Date.parse(eventEnd);

  if (!hasStarted && !hasEnded) {
    if (eventStart && showCountdown) {
      initializeClock(eventStart);
    }

    $(".event_before_start").removeClass("d-none").slideDown("fast");
    $(".event_before_end").removeClass("d-none").slideDown("fast");

  } else if (hasStarted && !hasEnded) {
    if (eventEnd && showCountdown) {
      initializeClock(eventEnd);
    }

    $(".event_after_start").removeClass("d-none").slideDown("fast");
    $(".event_before_end").removeClass("d-none").slideDown("fast");

  } else if (hasStarted) {
    $(".event_after_start").removeClass("d-none").slideDown("fast");
  }

  if (hasEnded) {
    $(".event_before_end").addClass("d-none");
    $(".event_after_end").removeClass("d-none").slideDown();
  }
});

function initializeClock(endtime) {
  const clock = document.getElementById("countdown_clock_widget");
  if (!clock){
    console.log("no clock widget");
  };

  // Wrap in a closure to retain reference to interval ID
  let intervalRef = null;

  const tick = () => updateClock(clock, endtime, intervalRef);
  tick();
  intervalRef = setInterval(tick, 1000);
}

function getTimeRemaining(endtime) {
  const t = Date.parse(endtime) - Date.now();
  return {
    total: t,
    days: Math.floor(t / (1000 * 60 * 60 * 24)),
    hours: Math.floor((t / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((t / (1000 * 60)) % 60),
    seconds: Math.floor((t / 1000) % 60),
  };
}

function updateClock(clock, endtime, intervalRef) {
  const t = getTimeRemaining(endtime);

  if (t.total <= 0) {
    $(".event_before_end").slideUp("fast");
    clearInterval(intervalRef);
    return;
  }

  const daysSpan = clock.querySelector(".days");
  const hoursSpan = clock.querySelector(".hours");
  const minutesSpan = clock.querySelector(".minutes");
  const secondsSpan = clock.querySelector(".seconds");

  daysSpan.innerHTML = t.days;
  hoursSpan.innerHTML = String(t.hours).padStart(2, "0");
  minutesSpan.innerHTML = String(t.minutes).padStart(2, "0");
  secondsSpan.innerHTML = String(t.seconds).padStart(2, "0");
}
